import { CContainer } from '@coreui/react-pro'
import { isEmpty } from 'lodash'
import React, { Suspense, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { fetchSettings, logout } from 'src/actions'
import { HOME_PAGE } from 'src/constants/PermissionConstants'
import useIdle from 'src/hooks/useIdleTimer'
import { isUserEmployee } from 'src/selectors/AuthSelector'
import { ACCESS_TOKEN_NAME, LOGOUT_IDLE_TIME_MINUTES } from '../constants/Constants'
import routes from '../routes'
import Loader from './Loader'
import { ROUTE } from 'src/constants/RouteConstants'

const AppContent = () => {
  const token = localStorage.getItem(ACCESS_TOKEN_NAME)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth)
  const settings = useSelector((state) => state.settings?.settings)
  const isEmployee = useSelector(isUserEmployee)

  const permissions = auth.permissions.map((p) => {
    return p.name
  })
  const [idleTimer, setIdleTimer] = useState(LOGOUT_IDLE_TIME_MINUTES)

  const allowedRoutes =
    token && auth?.isLoggedIn
      ? routes?.filter((route) => {
          return (
            (route.permissions
              ? route.permissions?.find((permission) => permissions?.includes(permission))
              : false) || route.permissions.includes(HOME_PAGE)
          )
        })
      : routes

  const logoutUser = () => {
    dispatch(logout())
    navigate(ROUTE.LOGIN, { replace: true })
    window.location.reload()
  }

  useIdle({ onIdle: logoutUser, idleTime: idleTimer })

  useEffect(() => {
    if (auth.isLoggedIn) {
      dispatch(fetchSettings(settings))
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(settings) && settings instanceof Array) {
      setIdleTimer(
        settings?.find((s) => s.key === 'idle' && s.code === 'timer')?.value ??
          LOGOUT_IDLE_TIME_MINUTES,
      )
    }
  }, [settings])

  return (
    <CContainer className="px-0" fluid>
      <Suspense fallback={<Loader />}>
        <Routes>
          {allowedRoutes?.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={
                    token && auth?.isLoggedIn ? (
                      auth.email_verified_at ? (
                        <route.element />
                      ) : (
                        <Navigate to="/user-reset-password" replace />
                      )
                    ) : (
                      <Navigate to="/login" replace />
                    )
                  }
                />
              )
            )
          })}
          <Route exact path="/home" element={<Navigate to="/" replace />} />
          <Route
            exact
            path="/dashboard"
            element={<Navigate to={isEmployee ? 'dashboards/dashboard' : 'dashboard'} replace />}
          />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
